import { useAuth } from "@stardeck/client-auth";
import { IframeWrapper } from "@stardeck/client-utils";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { queryClient } from "@/lib/react-query";
import AuthTest from "@/pages/auth-test";
import { Home } from "@/pages/home";
import { NotFound } from "@/pages/not-found";

function App() {
  const { mode } = useAuth();

  const content = (
    <div className="min-h-screen bg-gray-50">
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/auth-test" element={<AuthTest />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );

  return (
    <QueryClientProvider client={queryClient}>
      <Router>{mode === "iframe" ? <IframeWrapper>{content}</IframeWrapper> : content}</Router>
    </QueryClientProvider>
  );
}

export default App;
